/*
  File: module/fwn.js
  Release: v20260805.1-hotfix-hotfix-hotfix-hotfix-hotfix-hotfix
  Commit: 099012d2c784e93e2163105085627ca1a6779dca
  Stage: production
  Date: 2026-08-10T16:49:22.969Z
  Bundler: Vite
*/
import"./chunks/fwn/DHUdEqpm.js";
